import { render, staticRenderFns } from "./CollectionUpdateScreen.vue?vue&type=template&id=024b6f2a&"
import script from "./CollectionUpdateScreen.vue?vue&type=script&lang=js&"
export * from "./CollectionUpdateScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports